<!-- to-do remove -->
<template>
  <div 
    class="fts-feedback-indicate" 
    :class="[{modal: modal}, getClass]"
    v-if="visibility">
    <!-- modal -->
    <template v-if="modal">
      <fts-modal
        :header="false"
        :footer="false"
        contentClass="fi-modal-body"
        width="365px"
        @close="close()"
        v-if="showModal">
        <template #body>
          <fts-feedback-indicate
            child 
            @close="close"
            ref="child">
            <slot name="media" slot="media" />
            <template #action="{uid, close}">
              <slot name="action" :uid="uid" :close="close" />
            </template>
          </fts-feedback-indicate>  
        </template>
      </fts-modal>
    </template>
    <!-- fi -->
    <template v-else>
      <!-- ilus -->
      <slot name="media">
        <div class="fi-ilus-wrapper">
          <font-awesome-icon :icon="['fas', 'check']" fixed-width class="fi-ilus-icon" v-if="fiType === 'success'" />
          <font-awesome-icon :icon="['fas', 'times']" fixed-width class="fi-ilus-icon" v-else-if="fiType === 'error'"/>
          <font-awesome-icon :icon="['fas', 'info']" fixed-width class="fi-ilus-icon" v-else/>
        </div>
      </slot>
      <!-- title -->
      <div class="fi-title">{{fiTitle}}</div>
      <!-- desc -->
      <div class="fi-desc">{{fitDesc}}</div>  
      <!-- action -->
      <div class="fi-action" v-if="!disabledAction">
        <slot name="action" :uid="uid" :close="close">
          <fts-btn color="success" textTransformInit @click="close" v-if="fiType === 'success'">
            Continue
          </fts-btn>
          <fts-btn color="danger" textTransformInit @click="close" v-else-if="fiType === 'error'">
            Try Again
          </fts-btn>
          <fts-btn color="primary" textTransformInit @click="close" v-else>
            Default
          </fts-btn>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
import FTSModal from "./FTSModal";
import FTSBtn from "./FTSBtn";

const types = ['success', 'error', 'notFound', 'notfoundAddNew']

export default {
  name: "fts-feedback-indicate",
  components: {
    "fts-modal": FTSModal,
    "fts-btn": FTSBtn,
  },
  props: {
    modal: Boolean,
    child: Boolean,
  },
  data: () => ({
    visible: false,
    showModal: false,
    type: null,
    uid: null,
    title: null,
    desc: null,
    response: null,
    disabledAction: false,
    handler: null,
  }),
  methods: {
    show(data) {
      try {
        if (this.modal) {
          this.showModal = true;
          this.handler = data.handler;
          this.$nextTick(() => {
            this.$refs.child.show(data);
          });
        } else {     
          this.visible = true;
          this.type = data.type;
          this.uid = data.uid;
          this.title = data.title;
          this.desc = data.desc;
          this.response = data.response;
          this.disabledAction = data.disabledAction;
          if (!this.child) {
            this.handler = data.handler;
          }
        }      
      } catch(err) {
        this.reset()
      }
    },
    async close() {
      if (this.handler && typeof this.handler === 'function') {
        await this.handler();
      } 

      if (this.child) 
        this.$emit('close');

      this.reset();
    },
    reset() {
      if (this.modal)
        this.showModal = false;
      else
        this.visible = false;

      this.type = null;
      this.uid = null;
      this.title = null;
      this.desc = null;
      this.response = null;
      this.disabledAction = false;
      this.handler = null;
    },
  },
  computed: {
    visibility() {
      return this.modal ? true : this.visible
    },
    fiType() {    
      if (this.type && types.indexOf(this.type) > -1)
        return this.type
    },
    fiTitle() {
      if (this.responseData.title) 
        return this.responseData.title;
      else if (this.title)
        return this.title;
      else
        switch (this.fiType) {
          case "success":
            return "Success";
          case "error":
            return "An Error Occurred";
          case "notFound":
          case "notfoundAddNew":
            return "No Results";
          default:
            return "Default Title";
        }
    },
    fitDesc() {
      if (this.responseData.desc)
        return this.responseData.desc;
      else if (this.desc)
        return this.desc;
      else 
        switch (this.fiType) {
          case "success":
            return "Everything is working normally.";
          case "error":
            return "Something went wrong. Let's try this again.";
          case "notFound":
            return "Try using different keywords or adjusting your filters.";
          case "notfoundAddNew":
            return "Looks a little bit empty here.";
          default:
            return "default description.";
        }
    },
    getClass() {
      switch (this.fiType) {
        case "success":
          return "success";
        case "error":
          return "error";
      }
    },
    responseData() {
      if (this.response) {
        const status = this.response.status;
        const message = this.response.data && this.response.data.message;
        let res = {}
        if (status === 401) 
          res.title = "Error 401. Unauthorized.";
        if (message) 
          res.desc = message;
        return res;
      } else {
        return {};
      }
    }
  }
}
</script>

<style lang="scss">
.fts-feedback-indicate {
  &:not(.modal) {
    padding: 3rem 2.15rem;
    text-align: center;
  }
  &.success {
    .fi-ilus-wrapper {
      border-color: var(--fts-success);
      color: var(--fts-success);
    }
    .fi-title {
      color: var(--fts-success);
    }
  }
  &.error {
    .fi-ilus-wrapper {
      border-color: var(--fts-danger);
      color: var(--fts-danger);
    }
    .fi-title {
      color: var(--fts-danger);
    }
  }
}
.fi-ilus-wrapper {
  height: 80px;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  border: 2px solid var(--fts-primary);
  border-radius: 50%;
  color: var(--fts-primary);
  .fi-ilus-icon {
    color: inherit;
    font-size: 2.5rem;
  }
}
.fi-title {
  margin-bottom: .575rem;
  color: var(--fts-primary);
  font-size: 1.25rem;
  font-weight: 600;
}
.fi-desc {
  margin-bottom: 2rem;
  overflow-wrap: break-word;
  color: var(--fts-gray-400);
  font-size: .875rem;
  line-height: 1.5;
}

</style>